import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinpunesolapurhighway() {



const cardData =
  {
    keyword: 'Bus On Rent in Pune Solapur Highway',
    heading: 'Sanavi Travels: Bus On Rent in Pune Solapur Highway',
    headingDescription: 'Sanavi Travels offers professional and reliable Bus On Rent in Pune Solapur Highway, catering to the high-demand travel corridor connecting Pune with Solapur and surrounding regions. The Pune Solapur Highway is one of the busiest routes in Maharashtra, widely used for corporate travel, industrial commuting, wedding transportation, school trips, picnic tours, and long-distance outstation journeys. To serve diverse group travel requirements, we provide a wide range of AC buses, Non-AC buses, luxury coaches, mini buses, and high-capacity buses designed for both short and long highway travel. Each bus is well-maintained with comfortable seating, smooth suspension, proper ventilation, and ample luggage space, ensuring a relaxed and safe journey even on extended routes. Our experienced drivers are highly familiar with highway driving conditions, traffic patterns, toll routes, and safety protocols, ensuring punctual pickups and smooth travel. With flexible rental plans, transparent pricing with no hidden costs, and 24/7 customer assistance, bus rental on Pune Solapur Highway becomes convenient, economical, and stress-free. Choose Sanavi Travels for dependable, comfortable, and professionally managed bus rental services on Pune Solapur Highway for every travel purpose.',

    top: 'Top Places Along Pune Solapur Highway with Sanavi Travels',


"topPlaces": [
  {
    "title": "Pune City Access Points",
    "description": "The Pune Solapur Highway connects several major access points of Pune city, making it a preferred route for corporate travelers, educational institutions, and event groups. Bus travel along this stretch allows large groups to move together efficiently while avoiding multiple vehicles and coordination issues. The highway offers smooth road conditions suitable for long-distance bus travel, ensuring comfort and time efficiency."
  },
  {
    "title": "Industrial Zones and MIDC Areas",
    "description": "Multiple industrial estates and MIDC zones are located along the Pune Solapur Highway, generating daily demand for employee transportation, factory staff movement, and corporate travel. Bus hire services play a critical role in organizing safe, punctual, and cost-effective group transport for companies operating in these industrial clusters."
  },
  {
    "title": "Wedding Lawns and Event Venues",
    "description": "Several wedding lawns, banquet halls, and event venues are situated along the Pune Solapur Highway due to easy accessibility and spacious surroundings. Bus rentals are widely used to transport wedding guests and event attendees in an organized manner, reducing parking issues and ensuring timely arrivals."
  },
  {
    "title": "Educational Institutions and Campuses",
    "description": "Schools, colleges, coaching centers, and training institutes located near the highway frequently organize excursions, sports events, and educational tours. Hiring buses ensures student safety, disciplined travel, and proper supervision during group journeys."
  },
  {
    "title": "Daund Junction Connectivity",
    "description": "Daund, a major railway and road junction connected by the Pune Solapur Highway, attracts travelers for business, logistics, and regional connectivity. Bus travel provides a comfortable and reliable solution for group movement between Pune, Daund, and nearby towns."
  },
  {
    "title": "Rural Villages and Agricultural Belt",
    "description": "The highway passes through several rural villages and agricultural areas, supporting frequent travel for social functions, family gatherings, and local festivals. Bus hire services help manage large-group travel smoothly across these regions."
  },
  {
    "title": "Picnic and Leisure Spots",
    "description": "Open landscapes, countryside locations, and seasonal picnic spots near the highway attract schools, offices, and families. Buses offer a safe and enjoyable mode of transport, allowing groups to travel together and enjoy the journey without logistical stress."
  },
  {
    "title": "Religious and Cultural Destinations",
    "description": "Various temples and cultural sites near the Pune Solapur Highway are visited throughout the year by devotees and tour groups. Bus rentals make pilgrimages convenient, economical, and organized for large groups."
  },
  {
    "title": "Corporate Travel Corridors",
    "description": "The highway serves as a major corridor for corporate meetings, site visits, and employee commuting between Pune and Solapur-side industrial zones. Bus hire ensures punctuality, comfort, and professional travel management."
  },
  {
    "title": "Outstation Travel Routes",
    "description": "Pune Solapur Highway provides seamless connectivity to Solapur, Osmanabad, Kalaburagi, and other regions. Bus rentals are ideal for outstation tours, pilgrimages, and extended group travel with comfort and safety."
  }
]
,



"services": [
{
"name": "Bus On Rent in Pune Solapur Highway",
"description": "Bus On Rent in Pune Solapur Highway offers reliable, spacious, and comfortable buses for corporate groups, families, schools, wedding guests, and tourists traveling along this busy corridor. These buses are designed for highway travel with comfortable seating, smooth suspension, proper ventilation, and ample luggage space, ensuring a relaxed journey even on long routes. Professional drivers experienced in highway driving ensure safe speeds, disciplined travel, and punctual arrivals."
},
{
"name": "Bus Hire Pune Solapur Road",
"description": "Bus Hire Pune Solapur Road provides flexible rental solutions for daily travel, events, and long-distance group movement. This service supports scheduled pickups, multi-stop routes, and customized travel plans for different group sizes and purposes."
},
{
"name": "AC Bus Rental Pune Solapur Highway",
"description": "AC Bus Rental Pune Solapur Highway ensures a cool and comfortable travel experience, especially during summer months and long journeys. Fully air-conditioned interiors, cushioned seating, and reduced fatigue make AC buses ideal for corporate trips, weddings, and extended tours."
},
{
"name": "Non AC Bus Hire Solapur Road Pune",
"description": "Non AC Bus Hire Solapur Road Pune offers economical and dependable transportation for short-distance and budget-friendly group travel. These buses are suitable for rural routes, school trips, and frequent travel requirements."
},
{
"name": "Luxury Bus on Rent Pune Solapur Road",
"description": "Luxury Bus on Rent Pune Solapur Road delivers premium travel with modern interiors, stylish seating, and superior comfort. Ideal for VIP guests, weddings, and high-profile corporate travel, luxury buses ensure a refined journey."
},
{
"name": "Mini Bus Hire Pune Solapur Highway",
"description": "Mini Bus Hire Pune Solapur Highway is suitable for small to medium groups such as office teams, family outings, and local events. Mini buses offer flexibility, easy maneuverability, and cost-effective travel solutions."
},
{
"name": "32 Seater Bus on Rent Solapur Road",
"description": "32 Seater Bus on Rent Solapur Road is ideal for medium-sized groups including school tours, corporate outings, and social functions, offering balanced capacity and comfort."
},
{
"name": "35 Seater Bus Hire Pune Solapur Highway",
"description": "35 Seater Bus Hire Pune Solapur Highway supports large-group travel needs such as weddings, religious tours, and outstation trips with organized seating and professional service."
},
{
"name": "Bus on Rent Solapur Road for Wedding",
"description": "Bus on Rent Solapur Road for Wedding ensures smooth guest transportation, coordinated schedules, and stress-free travel management for wedding events."
},
{
"name": "Bus Hire Solapur Highway for Corporate",
"description": "Bus Hire Solapur Highway for Corporate provides punctual and professional transportation for employee movement, meetings, conferences, and corporate events."
},
{
"name": "Bus Rental Solapur Road for Picnic",
"description": "Bus Rental Solapur Road for Picnic offers safe and enjoyable transportation for school picnics, office outings, and family leisure trips."
},
{
"name": "Bus Hire Pune Solapur Highway Outstation",
"description": "Bus Hire Pune Solapur Highway Outstation offers dependable long-distance travel solutions for tours, pilgrimages, and multi-day journeys with passenger comfort as a priority."
},
{
"name": "Bus Hire Solapur Road with Driver",
"description": "Bus Hire Solapur Road with Driver provides chauffeur-driven buses with experienced drivers managing routes, traffic, and safety protocols."
},
{
"name": "Affordable Bus Rental Solapur Highway",
"description": "Affordable Bus Rental Solapur Highway delivers cost-effective bus hire solutions without compromising safety, cleanliness, or service quality."
},
{
"name": "Best Bus Service Pune Solapur Road",
"description": "Best Bus Service Pune Solapur Road is known for clean buses, disciplined drivers, transparent pricing, and reliable customer support, making Sanavi Travels a preferred choice."
}
],
"tableData": [
["Bus On Rent Pune Solapur Highway", "Bus Hire Pune Solapur Road"],
["AC Bus Rental Solapur Road", "Non AC Bus Hire Solapur Road"],
["Luxury Bus Pune Solapur", "Mini Bus Hire Solapur Road"],
["32 Seater Bus Solapur Road", "35 Seater Bus Pune Solapur"],
["Wedding Bus Solapur Road", "Corporate Bus Solapur Highway"],
["Picnic Bus Solapur Road", "Outstation Bus Solapur Road"],
["Bus Hire with Driver", "Affordable Bus Rental Solapur"],
["Best Bus Service Pune Solapur", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Pune Solapur Highway with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels is a trusted provider of highway bus rental services for corporate, social, and long-distance travel."
  },
  {
    "WhyChooseheading": "Highway-Ready Buses",
    "WhyChoosedescription": "Our buses are well-maintained and designed specifically for smooth and safe highway journeys."
  },
  {
    "WhyChooseheading": "Experienced Highway Drivers",
    "WhyChoosedescription": "Drivers are trained for long-distance and highway driving, ensuring passenger safety and punctuality."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Clear pricing with no hidden charges makes planning group travel easy and reliable."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team remains available round the clock for assistance and coordination."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose hourly, daily, or multi-day bus rental options based on travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are cleaned and sanitized before every trip for passenger safety."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure disciplined operations and punctual pickups on busy highway routes."
  }
]

}

const faqData = [
  {
    question: 'Do you provide bus rental services on Pune Solapur Highway?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services along Pune Solapur Highway for all travel needs.'
  },
  {
    question: 'Are AC and Non AC buses available?',
    answer: 'Yes, we provide both AC and Non AC buses based on travel requirements.'
  },
  {
    question: 'Is bus rental available for weddings and corporate travel?',
    answer: 'Yes, we offer dedicated buses for weddings, corporate events, and employee transportation.'
  },
  {
    question: 'Can I book buses for outstation travel?',
    answer: 'Yes, outstation bus rentals are available from Pune Solapur Highway.'
  },
  {
    question: 'Are the buses sanitized?',
    answer: 'Yes, all buses are sanitized before each journey.'
  },
  {
    question: 'Is customer support available 24x7?',
    answer: 'Yes, our customer support team is available round the clock.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Kulkarni',
    feedback: 'We hired a bus on Pune Solapur Highway for corporate travel. Very professional and punctual service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Jadhav',
    feedback: 'Sanavi Travels provided a clean and comfortable bus for our picnic via Solapur Road. Excellent experience.',
    rating: 5
  }
];














  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Pune Solapur Highway - Sanavi Travels",
  "description": "Sanavi Travels provides bus on rent in Pune Solapur Highway for weddings, corporate travel, picnics, and outstation trips. We offer AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "190"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus On Rent in Pune Solapur Highway | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus on rent in Pune Solapur Highway with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/220.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinpunesolapurhighway;